import debounce from 'debounce';
class TaxoFilters extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.js-trigger');
    this.list = this.querySelector('.js-list');
    // Initialize open state based on aria-expanded attribute
    this.open = this.trigger.getAttribute('aria-expanded') === 'true';
  }
  connectedCallback() {
    // bindings
    this.bndHandleResize = debounce(this.handleResize.bind(this), 250);
    this.bndToggle = this.toggle.bind(this);
    this.bndHandleKeydown = this.handleKeydown.bind(this);

    // events
    this.onLoad();
    window.addEventListener('resize', this.bndHandleResize);
    this.trigger.addEventListener('click', this.bndToggle);
    document.addEventListener('keydown', this.bndHandleKeydown);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.bndHandleResize);
    window.removeEventListener('load', this.bndScrollToContent);
    this.trigger.removeEventListener('click', this.bndToggle);
    document.removeEventListener('keydown', this.bndHandleKeydown);
  }
  onLoad() {
    // Ensure state matches the aria-expanded attribute
    this.updateDisclosureState();
  }
  toggle() {
    this.open = !this.open;
    this.updateDisclosureState();
  }
  updateDisclosureState() {
    // Update ARIA attributes
    this.trigger.setAttribute('aria-expanded', this.open ? 'true' : 'false');

    // Toggle hidden attribute on list
    if (this.open) {
      this.list.removeAttribute('hidden');
      this.trigger.classList.add('is-open');
    } else {
      this.list.setAttribute('hidden', '');
      this.trigger.classList.remove('is-open');
    }
  }
  handleKeydown(event) {
    // Close on Escape key press
    if (event.key === 'Escape' && this.open) {
      this.open = false;
      this.updateDisclosureState();
      // Return focus to the trigger button
      this.trigger.focus();
    }
  }
  handleResize() {
    // Implement resize handling if needed
  }
}
customElements.define('taxo-filters', TaxoFilters);